/********************************************
 * Testimonials Carousel
 *
 * Flickity carousel
 * https://flickity.metafizzy.co/
 ********************************************/
function fnTestimonialsCarousel(i, oSection) {

    /*****************
     * Objects
     *****************/
    var oSection = $(oSection),
        oCarousel = $('.carousel', oSection),
        oArrows	= $( '.nav-arrows', oSection ),
        oSlides = $('.testimonial', oSection);


    /*****************
     * Carousel configuration
     *****************/

    /**
     * Initialise Flickity
     */

    if (oSlides.length > 1) {
        var $oFlickity = oCarousel.flickity({
            cellAlign: 'left',
            accessibility: false,
            prevNextButtons: false,
            pageDots: false,
            adaptiveHeight: true,
            fade: true,
        });

        /**
         * Arrow buttons (prev/next)
         */
        oArrows.find( '.next' ).on( 'click', function() {
            $oFlickity.flickity( 'next' );
        });
        oArrows.find( '.previous' ).on( 'click', function() {
            $oFlickity.flickity( 'previous' );
        });
    }

}


// END OF DOCUMENT
